import { ButtonHTMLAttributes, forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { ButtonRef } from '../models/IButtonRef';

export interface MyButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  proceed?: () => void;
  text: string;
  class: string;
  disabled?: boolean;
}

const ButtonCustom = forwardRef<ButtonRef, MyButtonProps>((props, ref) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [isDisabled, setIsDisabled] = useState(props.disabled ?? false);

  // Define custom event handlers
  useImperativeHandle(ref, () => ({
    focus: () => {
      buttonRef.current?.focus();
    },
    disable: () => {
      buttonRef.current?.setAttribute('disabled', 'true');
      setIsDisabled(true);
    },
    enable: () => {
      buttonRef.current?.removeAttribute('disabled');
      setIsDisabled(false);
    },
    blur: () => {
      buttonRef.current?.blur();
    },
  }));

  return (
    <>
      <button type="button" ref={buttonRef} onClick={props?.proceed} disabled={isDisabled} className={props?.class}>
        {props?.text}
      </button>
    </>
  );
});

export default ButtonCustom;
